module.exports = __webpack_public_path__ + "static/media/Nota Cocina Molecular.a659f7f0.jpg";